<template>
  <b-card>
    <validation-observer
      ref="infoRules"
      v-slot="{ invalid }"
      tag="form"
    >
      <b-row>
        <b-col md="6">
          <validation-provider
            #default="validationContext"
            name="Name"
            rules="required"
          >
            <b-form-group
              label="Name"
              label-for="name"
            >
              <b-form-input
                id="name"
                v-model="manufactureForm.name"

                :state="getValidationState(validationContext)"
                trim
                placeholder="Name"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="6">
          <validation-provider
            #default="validationContext"
            name="address"
            rules="required"
          >
            <b-form-group
              label="Address"
              label-for="Address"
            >
              <b-form-input
                id="address"
                v-model="manufactureForm.address"
                :state="getValidationState(validationContext)"
                placeholder="Address"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="6">
          <validation-provider
            #default="validationContext"
            name="code"
            rules="required"
          >
            <b-form-group
              label="Code"
              label-for="Code"
            >
              <b-form-input
                id="code"
                v-model="manufactureForm.code"
                :state="getValidationState(validationContext)"
                placeholder="Code"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="6">
          <validation-provider
            #default="validationContext"
            name="status"
            rules="required"
          >
            <b-form-group
              label="Status"
              label-for="Status"
            >
              <b-form-select
                id="status"
                v-model="manufactureForm.status"
                :options="optionsStatus"
                :state="getValidationState(validationContext)"
                placeholder="Status"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="6">
          <validation-provider
            #default="validationContext"
            name="activities"
            rules="required"
          >
            <b-form-group
              label="activities"
              label-for="activities"
            >
              <b-form-input
                id="activities"
                v-model="manufactureForm.activities_text"
                placeholder="activities"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="12">
          <b-form-group
            label="products"
            label-for="products"
          >
            <multiselect
              id="products"
              v-model="manufactureForm.products"
              :options="optionsActivitiesProducts"
              :multiple="true"
              placeholder="Type to search"
              label="text"
              track-by="value"
            ><template v-slot:noResult>
              Oops! No elements found. Consider changing the search query.
            </template>
            </multiselect>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group
            label="sub products"
            label-for="sub products"
          >
            <multiselect
              id="option-groups"
              v-model="manufactureForm.sub_products"
              :options="optionsActivitiesSubProducts"
              :multiple="true"
              group-values="options"
              group-label="label"
              :group-select="true"
              placeholder="Type to search"
              track-by="text"
              label="text"
            ><template v-slot:noResult>
              Oops! No elements found. Consider changing the search query.
            </template>
            </multiselect>
          </b-form-group>
        </b-col>

        <b-col
          v-if="Object.values(errors).length > 0"
          cols="12"
        >
          <p
            v-for="(error, key, index) in errors"
            :key="index"
            class="text-danger small"
          >
            {{ error.toString() }}
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="mt-50"
        >

          <b-button
            v-if="!loader && $route.params.id"
            variant="primary"
            class="mr-1"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="addManufacture()"
          >
            Save Changes
          </b-button>
          <b-button
            v-if="!loader && !$route.params.id"
            variant="primary"
            class="mr-1"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="addManufacture()"
          >
            Add
          </b-button>
          <b-button
            v-if="loader"
            variant="primary"
            disabled
            class="mr-1"
          >
            <b-spinner
              small
              type="grow"
            />
            Loading...
          </b-button>
        </b-col>
      </b-row>
    </validation-observer>
  </b-card>
</template>

<script>
import { ref } from '@vue/composition-api'
import Multiselect from 'vue-multiselect'
import formValidation from '@core/comp-functions/forms/form-validation'
import axios from 'axios'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import decryptData from '@/store/auth/decryptData'

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      required,
      loader: false,
      validationErrors: {},
      errors: {},
      optionsStatus: [{ value: 0, text: '🔴 Not Active' }, { value: 1, text: '🟢 Active' }],
      manufactureActivities: [],
    }
  },
  setup() {
    const { getValidationState } = formValidation()
    // eslint-disable-next-line camelcase

    const manufactureForm = ref({})
    return {
      getValidationState,
      manufactureForm,
    }
  },
  computed: {
    optionsActivitiesSubProducts() {
      return this.$store.getters['generalData/activities/activitiesSubProducts']
    },
    optionsActivitiesProducts() {
      return this.$store.getters['generalData/activities/activities']
    },
  },

  async mounted() {
    if (!this.$store.getters['generalData/activities/activitiesLoaded']) {
      await this.$store.dispatch('generalData/activities/fetchActivities')
    }
    if (this.$route.params.id) {
      this.showManufacture()
    }
  },
  methods: {
    showManufacture() {
      axios.get(`manufacture-white-lists/${this.$route.params.id}`).then(res => {
        const manufactureData = decryptData(res.data.payload).data.manufacture
        const newOptionsActivitiesSubProducts = this.optionsActivitiesSubProducts.map(item => item.options).flat()

        const getActivitiesProduct = this.optionsActivitiesProducts.filter(val => manufactureData.products_ids.includes(val.value))
        const getActivitiesSubProduct = newOptionsActivitiesSubProducts.filter(val => manufactureData.sub_products_ids.includes(val.value))

        this.manufactureForm = {
          name: manufactureData.name,
          status: manufactureData.status,
          activities_text: manufactureData.activities_text,
          products: getActivitiesProduct,
          sub_products: getActivitiesSubProduct,
          address: manufactureData.address,
          code: manufactureData.code,
        }
      })
    },

    addManufacture() {
      if (this.$route.params.id) {
        this.loader = true
        const formData = new FormData()
        formData.append('_method', 'PUT')
        Object.keys(this.manufactureForm).forEach(key => {
          if (key === 'sub_products') {
            this.manufactureForm[key].forEach((element, index) => {
              formData.append(`sub_products[${index}]`, element.value)
            })
          } else if (key === 'products') {
            this.manufactureForm[key].forEach((element, index) => {
              formData.append(`products[${index}]`, element.value)
            })
          } else {
            formData.append(key, this.manufactureForm[key])
          }
        })

        axios.post(`manufacture-white-lists/${this.$route.params.id}`, formData).then(res => {
          if (res.status === 200) {
            this.$router.push({ name: 'manufacture-white' })
            this.$toasted.show('Updated Successfully', {
              position: 'top-center',
              duration: 3000,
            })
          }
        }).catch(error => {
          if (error.response.status) {
            const payload = decryptData(error.response.data.payload).message
            const firstArrayKey = Object.keys(payload).find(key => Array.isArray(payload[key]))
            const errorMessage = firstArrayKey ? payload[firstArrayKey][0] : 'An unknown error occurred'
            this.$toast({
              component: ToastificationContent,
              props: {
                title: errorMessage,
                icon: 'BellIcon',
                variant: 'error',
              },
            })
          }
        }).finally(() => {
          this.loader = false
        })
      } else {
        this.loader = true
        const formData = new FormData()
        Object.keys(this.manufactureForm).forEach(key => {
          if (key === 'sub_products') {
            this.manufactureForm[key].forEach((element, index) => {
              formData.append(`sub_products[${index}]`, element.value)
            })
          } else if (key === 'products') {
            this.manufactureForm[key].forEach((element, index) => {
              formData.append(`products[${index}]`, element.value)
            })
          } else {
            formData.append(key, this.manufactureForm[key])
          }
        })
        axios.post('manufacture-white-lists', formData).then(res => {
          if (res.status === 200 || res.status === 201) {
            this.$router.push({ name: 'manufacture-white' })
            this.$toasted.show('Created Successfully', {
              position: 'top-center',
              duration: 3000,
            })
          }
        }).catch(error => {
          if (error.response.status) {
            const payload = decryptData(error.response.data.payload).message
            const firstArrayKey = Object.keys(payload).find(key => Array.isArray(payload[key]))
            const errorMessage = firstArrayKey ? payload[firstArrayKey][0] : 'An unknown error occurred'
            this.$toast({
              component: ToastificationContent,
              props: {
                title: errorMessage,
                icon: 'BellIcon',
                variant: 'error',
              },
            })
          }
        }).finally(() => {
          this.loader = false
        })
      }
    },
  },

}
</script>

  <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
